/**
 * src/pages/OriginAndBeyond/OriginAndBeyond.tsx
 * Entry page component for Origin & Beyond (Hub).
 * Follows batch spec exactly:
 * - Route: /OriginAndBeyondPage
 * - Wrapped in <OriginPageShell accent="violet">
 * - Page order:
 *   1. HubHero (Signature visual canvas, exact H1, eyebrow, subline, dual CTA buttons)
 *   2. InteractiveJourney (Glowing curved path / mobile stepper, 4 nodes, details & exploration bullets)
 *   3. CosmicTimeRibbon (ScrubTimeline linking all 4 questions, exact numbers & footnotes)
 *   4. EvidenceSection (How to read this journey + EvidenceKey)
 *   5. IntegritySection (Honest about the unknown with DisclaimerNotes)
 *   6. RelatedExperiences (atlas, lab, kardashev, creator, selves, whatIf)
 *   7. SourceList (Sources [1..7])
 */

import React from "react";
import "./OriginAndBeyond.module.css";
import "@/components/cosmic/cosmic.css";
import { OriginPageShell } from "@/components/originBeyond/OriginPageShell";
import { RelatedExperiences } from "@/components/originBeyond/RelatedExperiences";
import { SourceList } from "@/components/originBeyond/SourceList";
import { HubHero } from "./sections/HubHero";
import { InteractiveJourney } from "./sections/InteractiveJourney";
import { CosmicTimeRibbon } from "./sections/CosmicTimeRibbon";
import { EvidenceSection } from "./sections/EvidenceSection";
import { IntegritySection } from "./sections/IntegritySection";
import { HUB_SOURCES } from "./originAndBeyondData";
export default function OriginAndBeyondPage() {
  return <OriginPageShell accent="violet">
      {/* 1. Hub Hero */}
      <HubHero />

      {/* 2. Interactive Journey Path & Exploration Panel */}
      <InteractiveJourney />

      {/* 3. Cosmic Time Ribbon (ScrubTimeline) */}
      <CosmicTimeRibbon />

      {/* 4. Evidence Key & Reading Guide */}
      <EvidenceSection />

      {/* 5. "Honest about the unknown" integrity callouts */}
      <IntegritySection />

      {/* 6. Related Quantum Liaison Experiences */}
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <RelatedExperiences keys={["atlas", "lab", "kardashev", "creator", "selves", "whatIf"]} title="Related Quantum Liaison Portals" />
      </div>

      {/* 7. Scholarly & Archival Sources */}
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 sm:pb-16">
        <SourceList sources={HUB_SOURCES} title="Scholarly & Cosmological Citations" />
      </div>
    </OriginPageShell>;
}